<div class="prompts-sidebar">
  <div class="prompts-sidebar-header">
    <div class="float-left switch-icon">
      <img class="select-switch-panel" src="/assets/images/select_switch_panel.svg"
        alt="Select Switch Panel">
    </div>
    <div class="float-right mt-2">
      <img class="product-exeperience" src="/assets/images/context-charts/netcore-logo.svg"
        alt="Netcore Customer Engagement">
    </div>
  </div>

  <div class="body-content">
    <div class="heading-text">Switch to</div>
    <div>
      <div routerLink="/overview" class="panel-box d-flex" (click)="handleDialogClose()">
        <div class="img-box">
          <img src="/assets/images/px_web.svg" alt="">
        </div>
        <div>
          <div class="panel-heading">
            Product Experience
          </div>
          <div class="panel-sub-heading">
            Send personalized nudges
          </div>
        </div>
      </div>
      <div class="panel-box d-flex" (click)="onCustomerEngagementClick()">
        <div class="img-box">
          <img src="/assets/images/ce_web.svg" alt="">
        </div>
        <div>
          <div class="panel-heading">
            Customer Engagement
          </div>
          <div class="panel-sub-heading">
            Increase conversion & retention
          </div>
        </div>
      </div>
    </div>
  </div>
</div>